import { Controller } from "stimulus";

export default class extends Controller {
  removeElement() {
    this.element.remove();
  }
}
